import React from 'react';
import FilterChips from '@/components/search/filters/filtersMenu/reusabe/filterChips/FilterChips';
import { useRouter } from 'next/router';
const Installment = () => {
  const router = useRouter();
  const query = router?.query;
  const submitSort = () => {
    router.push({
      query: {
        ...query,
        installment_payment: 1
      }
    });
  };
  const removeSort = () => {
    const removedQuery = {
      ...query
    };
    if (removedQuery?.installment_payment) {
      delete removedQuery?.installment_payment;
    }
    router.push({
      query: removedQuery
    });
  };
  return <FilterChips type="secondary" checked={!!query?.installment_payment} handleClick={submitSort} handleClean={removeSort} label={'قسطی'} endIcon={true} name="installment_filter" id="installment_filter_chip" data-sentry-element="FilterChips" data-sentry-component="Installment" data-sentry-source-file="Installment.tsx" />;
};
export default Installment;